import { MapPin } from "lucide-react";

/**
 * Renderiza um card de localização dentro de MessageBubble.
 * Exibe miniatura estática via OpenStreetMap (sem API key),
 * nome/endereço e link para abrir no Google Maps.
 *
 * @param {{ latitude: number, longitude: number, name?: string, address?: string }} props
 */
export default function LocationCard({ latitude, longitude, name, address }) {
  const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
  const staticImgUrl = [
    "https://staticmap.openstreetmap.de/staticmap.php",
    `?center=${latitude},${longitude}`,
    "&zoom=14&size=280x120",
    `&markers=${latitude},${longitude},red-marker`,
  ].join("");

  return (
    <div className="rounded-lg overflow-hidden border border-white/[0.08] bg-surface-2 w-60">
      {/* Miniatura estática via OpenStreetMap */}
      <a
        href={mapUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={name ? `Abrir ${name} no mapa` : "Abrir localização no Google Maps"}
        tabIndex={0}
        className="block focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
      >
        <img
          src={staticImgUrl}
          alt={name ? `Mapa: ${name}` : "Mapa de localização"}
          width={280}
          height={120}
          loading="lazy"
          className="w-full h-[80px] object-cover bg-surface-3"
        />
      </a>

      {/* Informações textuais */}
      <div className="px-3 py-2 flex items-start gap-2">
        <MapPin
          className="w-3.5 h-3.5 text-brand-400 flex-shrink-0 mt-0.5"
          aria-hidden="true"
        />
        <div className="flex-1 min-w-0">
          {name && (
            <p className="text-xs font-semibold text-ink-1 truncate leading-tight">
              {name}
            </p>
          )}
          {address && (
            <p className="text-xs text-ink-3 truncate leading-tight mt-0.5">
              {address}
            </p>
          )}
          {!name && !address && (
            <p className="text-xs text-ink-3 font-mono">
              {Number(latitude).toFixed(5)}, {Number(longitude).toFixed(5)}
            </p>
          )}
        </div>
      </div>

      {/* Link de abertura */}
      <div className="px-3 pb-2.5">
        <a
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-brand-400 hover:text-brand-300 transition-colors focus:outline-none focus-visible:underline"
        >
          Abrir no mapa
        </a>
      </div>
    </div>
  );
}
